import { CategoryRounded } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Scrollbar } from 'app/components';
import { useAsyncAction } from 'app/services';
import { geofenceOptionsUpdate } from 'app/store/map';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

const MapLeafletGeofenceShapeChangeDialog = (props) => {
  const { geofenceChangedItem } = useSelector((state) => state.map);
  const { open, onClose } = props;

  const {
    asyncAction: changeSubmit,
    isLoading: isChangeLoading,
    isSuccessful: isChangeSuccessful,
    isError: isChangeError,
  } = useAsyncAction(geofenceOptionsUpdate, [open]);

  const handleChangeClick = () => {
    const params = {
      type: 'shape',
      latitude: geofenceChangedItem.latitude,
      longitude: geofenceChangedItem.longitude,
    };

    switch (geofenceChangedItem.shape) {
      case 'Circle':
        params.shape = 'Polygon';
        params.radius = geofenceChangedItem.radius;
        params.edges = config.mapGeofenceOptions.polygonEdges;
        break;
      case 'Polygon':
        params.shape = 'Circle';
        params.radius = config.mapGeofenceOptions.defaultRadius;
        params.edges = config.mapGeofenceOptions.circleEdges;
        break;
    }

    changeSubmit(geofenceChangedItem.id, params);
  };

  useEffect(() => {
    if (isChangeSuccessful) {
      onClose();
    }
  }, [isChangeSuccessful]);

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      open={open}
      onClose={onClose}
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.MuiDialogTitle-root': {
          display: 'flex',
          padding: theme.spacing(2.5),
          alignItems: 'center',
        },
        '.MuiDialogTitle-root .MuiTypography-root': {
          marginLeft: theme.spacing(1.5),
        },
        '.MuiDialogTitle-root .MuiButtonBase-root': {
          marginLeft: 'auto',
        },
        '.MuiDialogContent-root': {
          padding: theme.spacing(0),
        },
        '.MuiDialogContent-root .simplebar-container': {
          padding: theme.spacing(0, 2.5),
        },
        '.MuiDialogActions-root': {
          padding: theme.spacing(2.5),
          justifyContent: 'flex-end',
        },
        '.MuiAvatar-circular': {
          bgcolor: alpha(theme.palette.primary.main, 0.12),
          'path, circle': {
            fill: theme.palette.primary.main,
          },
        },
        '.MuiAlert-root': {
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(2),
          borderRadius: theme.shape.borderRadius,
        },
      })}>
      <DialogTitle>
        <Avatar>
          <CategoryRounded fontSize='small' />
        </Avatar>
        <Typography component='p'>Изменить вид геозоны</Typography>
      </DialogTitle>
      <DialogContent>
        <Scrollbar>
          <Typography variant='caption'>Вы действительно хотите изменить вид геозоны?</Typography>
          {!isChangeLoading && isChangeError && (
            <Alert severity='error'>Произошла ошибка при изменении данных. Попробуйте снова или обратитесь в техническую поддержку.</Alert>
          )}
        </Scrollbar>
      </DialogContent>
      <DialogActions>
        <LoadingButton variant='contained' onClick={handleChangeClick} loading={isChangeLoading} disableElevation>
          Да
        </LoadingButton>
        <LoadingButton variant='outlined' onClick={onClose} disableElevation>
          Нет
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default MapLeafletGeofenceShapeChangeDialog;
